import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsersRoutingModule } from './users-routing.module';
import { UsersComponent } from './users.component';
import { UserListComponent } from './user-list/user-list.component';

import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatOptionModule } from '@angular/material/core';
import { ListModule } from 'src/@fury/shared/list/list.module';
import {MatDialogModule} from '@angular/material/dialog';
import { NgxMaskModule } from 'ngx-mask';
import { SharedModule } from 'src/app/shared/shared.module';
import { EditUserComponent } from './edit-user/edit-user.component';
import { RoleListComponent } from './role-list/role-list.component';
import { RoleAddEditComponent } from './role-add-edit/role-add-edit.component';
import { NgxMatTimepickerModule } from "ngx-mat-timepicker";
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule} from '@angular/material/core';
import {MatTabsModule} from '@angular/material/tabs';
import { ClaimUserListComponent } from './claim-user-list/claim-user-list.component';
import { TimeSchedulerTabComponent } from './common/time-scheduler-tab/time-scheduler-tab.component';
import { TimeSchedulerTableComponent } from './common/time-scheduler-table/time-scheduler-table.component';
import { AddEditTimeScheduleModalComponent } from './common/add-edit-time-schedule-modal/add-edit-time-schedule-modal.component';
import { PartnerUserListComponent } from './partner-user-list/partner-user-list.component';
import { ClaimUserRepLogModalComponent } from './modal/claim-user-rep-log-modal/claim-user-rep-log-modal.component';

const lang = "en-US";

@NgModule({
  declarations: [
    UsersComponent,
    UserListComponent,
    EditUserComponent,
    RoleListComponent,
    RoleAddEditComponent,
    ClaimUserListComponent,
    TimeSchedulerTabComponent,
    TimeSchedulerTableComponent,
    AddEditTimeScheduleModalComponent,
    PartnerUserListComponent,
    ClaimUserRepLogModalComponent
  ],
  imports: [
    CommonModule,
    UsersRoutingModule,
    FurySharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatCheckboxModule,
    MatIconModule,
    MatOptionModule,
    ListModule,
    NgxMaskModule,
    MatDialogModule,
    SharedModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    NgxMatTimepickerModule.setLocale(lang)
  ]
})
export class UsersModule { }
